/*
 * Update zepto position for engraving type inline
 */
 document.addEventListener("DOMContentLoaded", function () {

    function whenAvailable(DOM_element, callback, number_of_trys = 0) {
        number_of_trys += 1;
        const appEl = document.querySelector(DOM_element)
        const interval = 1000; 
    
        //console.log( number_of_trys)
        const int = window.setTimeout(function() {
            if (appEl) {
                callback(appEl);
                clearInterval(int)
            } else {
            console.log(`Waiting for DOM ENGRAVING INLINE ELEMENT ${DOM_element} to be available...`);
            number_of_trys <= 10 ? whenAvailable(DOM_element, callback, number_of_trys) : console.log("Reached limit for number_of_trys DOM ENGRAVING INLINE ELEMENT", number_of_trys);
            }
        }, interval);
    }

    whenAvailable(".product-personalizer", function(el) {
        console.log("Zepto INLINE script loaded");

        const zepto_inline_facade = document.querySelector('[data-js-zepto-facade-inline]');
        if(!zepto_inline_facade){
          return console.log('Cant find zepto inline face DOM')
        }

        zepto_inline_facade.appendChild(el);

        console.log(el)

    }, 10)
        

})